/**
 * delete-subject-context-relationship-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeleteSubjectContextRelationshipRequest
    extends ReplyVerifyingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag =
        MessageTag.REQ_DELETE_SUBJECT_CONTEXT_RELATIONSHIP;

    constructor (
        public subjectId : number,
        public relationshipId : number
    )
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/delete-subject-context-relationship-request.ts